import * as THREE from 'three'
// import Scoll from 'views/Scoll'
let TWEEN = require('@tweenjs/tween.js')

let tubeGeometry
let tubeGeometryLook

class Scene5 {
  constructor (loadmodel) {
    let lineOutEnd = loadmodel.scene.getObjectByName('s5_lookat_1')
    let lineOutEnd2 = loadmodel.scene.getObjectByName('s4_lookat_1')
    let lineOut = []
    lineOut.push(loadmodel.camera.position)
    for (var c = 1; c < 20; c++) {
      let point = loadmodel.scene.getObjectByName('s4_out3_' + c)
      lineOut.push(point.position)
    }
    lineOut.push(lineOutEnd.position)
    let pipeSplineOut = new THREE.CatmullRomCurve3(lineOut)
    tubeGeometry = new THREE.TubeGeometry(pipeSplineOut, 64, 0.02, 8, false)

    // lookat
    let lineOutLook = []
    lineOutLook.push(lineOutEnd2.position)
    lineOutLook.push(lineOutEnd.position)
    let pipeSplineOutLook = new THREE.CatmullRomCurve3(lineOutLook)
    tubeGeometryLook = new THREE.TubeGeometry(pipeSplineOutLook, 12, 0.02, 8, false)
  }

  Popup (loadmodel) {
    var scene1tan = document.getElementById('scene_2')
    scene1tan.style.display = 'none'
    var s1tishi1 = document.getElementById('s1_tishi_3')
    var text2 = document.getElementById('text_3')
    text2.innerHTML = ''
    s1tishi1.style.opacity = 0
    var blo1 = loadmodel.tween(s1tishi1.style).to({opacity: 1}, 2000).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      s1tishi1.style.display = 'block'
      var str = '国力强盛终圆千年飞天梦，<br>面对疾病万众一心顽强奋战,<br>奥运盛会让世界重新认识中国，<br>千禧之年开启世纪新篇章。'
      // console.log(str.length)
      let i = 0
      let timer = setInterval(function () {
        if (i <= str.length) {
          text2.innerHTML = str.slice(0, i++) + '|'
        } else {
          clearInterval(timer)
          text2.innerHTML = str
        }
      }, 30)
    }).onComplete(function () {
      let touchstart = function () {
        s1tishi1.style.display = 'none'
        window.removeEventListener('touchstart', touchstart, false)
        window.removeEventListener('click', touchstart, false)
        back.style.display = 'block'
      }
      window.addEventListener('touchstart', touchstart, false)
      window.addEventListener('click', touchstart, false)
    })
    blo1.start()
    let raycaster = new THREE.Raycaster()
    let door = loadmodel.scene.getObjectByName('s5_door')
    let list = []
    for (var i = 0; i < 2; i++) {
      list.push(loadmodel.scene.getObjectByName('s5_dian' + i))
    }
    // 关 注册返回
    let that = this
    let back = document.getElementById('return')
    let goBack = function () {
      that.GoOut(loadmodel)
      back.removeEventListener('touchstart', goBack, false)
      back.removeEventListener('click', goBack, false)
      back.style.display = 'none'
    }
    back.addEventListener('click', goBack, false)
    back.addEventListener('touchstart', goBack, false)
    // 点 开门
    let touchend = function (e) {
      let mouse = new THREE.Vector2()
      mouse.x = (e.x / window.innerWidth) * 2 - 1
      mouse.y = -(e.y / window.innerHeight) * 2 + 1
      raycaster.setFromCamera(mouse, loadmodel.camera)
      let intersects = raycaster.intersectObject(door)
      if (intersects.length > 0) {
        container.removeEventListener('click', clickFun, false)
          // console.log('点到了场景2到场景3')
        loadmodel.tweenClear()
        loadmodel.EndControls()
        let back = document.getElementById('return')
        back.removeEventListener('touchstart', goBack, false)
        back.removeEventListener('click', goBack, false)
        back.style.display = 'none'
        loadmodel.stats = 's5_1'
      }
      for (var j = 0; j < list.length; j++) {
        let intersects = raycaster.intersectObject(list[j])
        if (intersects.length > 0) {
            // console.log(j)
          var scene2tan = document.getElementById('scene_3')
          scene2tan.style.display = 'block'
          var len = scene2tan.getElementsByTagName('li')
          // console.log(len)
          for (var i = 0; i < len.length; i++) {
            len[i].style.display = 'none'
          }
          scene2tan.style.pointerEvents = 'auto'
          scene2tan.getElementsByTagName('li')[j].style.display = 'block'
        }
      }
    }
    let clickFun = function (event) {
      let point = new THREE.Vector2()
      point.x = event.clientX
      point.y = event.clientY
      touchend(point)
    }
    let container = document.getElementById('container')
    container.addEventListener('click', clickFun, false)
    // container.remove(EventListener('click', clickFun(event), false)
  }

  GoIn (loadmodel) {
    let tani = {t: 0.0, OldY: 0.0}
    let group = loadmodel.scene.getObjectByName('s5')
    group.visible = true
    let panoNew = loadmodel.scene.getObjectByName('s5_pano')
    panoNew.visible = true
    let that = this
    var go = loadmodel.tween(tani).to({t: 1.1}, 1000).easing(TWEEN.Easing.Quartic.In)
    go.start()
    loadmodel.sceneupdate = function () {
      var lookAt
      let lineOutEnd = loadmodel.scene.getObjectByName('s5_lookat_1')
      if (tani.t <= 1.09) {
        if (tani.t >= 0.1) {
          var pos = tubeGeometry.parameters.path.getPointAt(tani.t - 0.1)
          this.camera.position.copy(pos)
          lookAt = lineOutEnd.position
        } else {
          lookAt = tubeGeometryLook.parameters.path.getPointAt(tani.t * 10)
        }
        this.camera.lookAt(lookAt)
      } else {
        that.NextScene(loadmodel)
        that.StartTouch(loadmodel)
        document.getElementById('close3').addEventListener('click', function (e) {
          e.preventDefault()
          this.parentNode.style.display = 'none'
          // console.log(this.parentNode)
          // document.getElementById('scene_3').style.pointerEvents = 'none'
        })
      }
    }
  }

  GoOut (loadmodel) {
    loadmodel.EndControls()
    let tani = {t: 1.2}
    var go = loadmodel.tween(tani).to({t: 0}, 1000).easing(TWEEN.Easing.Quartic.In).onStart(function () {
      loadmodel.stats = 's3_b'
    })
    go.start()
    loadmodel.sceneupdate = function () {
      var lookAt
      let lineOutEnd = loadmodel.scene.getObjectByName('s5_lookat_1')
      let lineOutEnd2 = loadmodel.scene.getObjectByName('s4_lookat_1')
      if (tani.t > 0) {
        if (tani.t > 1.1) {
          let lineOut = []
          let end = tubeGeometry.parameters.path.getPointAt(0.99)
          lineOut.push(end)
          lineOut.push(loadmodel.camera.position)
          let pipeSplineOut = new THREE.CatmullRomCurve3(lineOut)
          let tubeGeometryCamera = new THREE.TubeGeometry(pipeSplineOut, 12, 0.02, 8, false)
          var pos = tubeGeometryCamera.parameters.path.getPointAt((tani.t - 1.1) * 10)
          this.camera.position.copy(pos)
          this.camera.lookAt(lineOutEnd.position)
        } else if (tani.t <= 1.1 && tani.t >= 0.1) {
          var pos2 = tubeGeometry.parameters.path.getPointAt(tani.t - 0.1)
          this.camera.position.copy(pos2)
          this.camera.lookAt(lineOutEnd.position)
        } else {
          lookAt = tubeGeometryLook.parameters.path.getPointAt(tani.t * 10)
          this.camera.lookAt(lookAt)
        }
      } else {
        let point = loadmodel.scene.getObjectByName('s4_out3_0')
        loadmodel.camera.position.copy(point.position)
        loadmodel.camera.lookAt(lineOutEnd2.position)
        loadmodel.ChangeControls(lineOutEnd2.position)
        loadmodel.sceneupdate = function () {}
      }
    }
  }

  StartTouch (loadmodel) {
    // console.log('走了4444444444')
    let lineOutEnd = loadmodel.scene.getObjectByName('s5_lookat_1')
    loadmodel.ChangeControls(lineOutEnd.position)
    loadmodel.sceneupdate = function () {}
  }

  NextScene (loadmodel) {
    let pano = new THREE.Group()
    loadmodel.scene.add(pano)
    pano.name = 's6'
    let lookat = loadmodel.scene.getObjectByName('s6_lookat_1')
    let lookat__ = loadmodel.scene.getObjectByName('s6_radis_3')
    let r = Math.abs(lookat.position.y - lookat__.position.y)
    let position = lookat.position
    // 添加点
    let dianMaterial = new THREE.MeshBasicMaterial({opacity: 0, transparent: true, color: 0xff0000})
    var list = []
    for (var k = 1; k < 6; k++) {
      list.push(loadmodel.scene.getObjectByName('s6_dian_' + k))
    }
    var dianBox
    // console.log(list.length)
    for (var j = 0; j < list.length; j++) {
      dianBox = new THREE.Mesh(new THREE.SphereBufferGeometry(r / 12, 60, 40), dianMaterial)
      dianBox.position.set(list[j].position.x, list[j].position.y, list[j].position.z)
      dianBox.name = 's6_dian' + j
      pano.add(dianBox)
    }
    // console.log(pano)
    let textures = this.getTexturesFromAtlasFile('static/images/p4/', 'jpg')
    let materials = []
    for (var i = 0; i < 6; i++) {
      materials.push(new THREE.MeshBasicMaterial({map: textures[i]}))
    }
    var skyBox = new THREE.Mesh(new THREE.CubeGeometry(r * 2, r * 2, r * 2), materials)
    skyBox.geometry.scale(-1, 1, 1)
    skyBox.position.set(position.x, position.y, position.z)
    skyBox.rotation.y = -1.5 * Math.PI
    skyBox.name = 's6_pano'
    skyBox.visible = true
    pano.add(skyBox)
    let materialdoor1 = new THREE.MeshBasicMaterial({opacity: 0, transparent: true, color: 0x00ff00})
    let OutDoor = loadmodel.scene.getObjectByName('s6_out_2')
    let geometryo = new THREE.SphereBufferGeometry(r / 6, 30, 30)
    let mesho = new THREE.Mesh(geometryo, materialdoor1)
    mesho.position.set(OutDoor.position.x, OutDoor.position.y, OutDoor.position.z)
    mesho.name = 's6_door'
    pano.add(mesho)
  }

  getTexturesFromAtlasFile (atlasImgUrl, tilesNum) {
    atlasImgUrl = 'static/images/p4/all4.jpg'
    tilesNum = 6
    var textures = []
    for (var i = 0; i < tilesNum; i++) {
      textures[i] = new THREE.Texture()
    }
    var imageObj = new Image()
    imageObj.onload = function () {
      var canvas, context
      var tileWidth = imageObj.height
      for (var i = 0; i < textures.length; i++) {
        canvas = document.createElement('canvas')
        context = canvas.getContext('2d')
        canvas.height = tileWidth
        canvas.width = tileWidth
        context.drawImage(imageObj, tileWidth * i, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth)
        textures[i].image = canvas
        textures[i].needsUpdate = true
      }
    }
    imageObj.src = atlasImgUrl
    return textures
  }

  getSigleTexture (Texture, image) {
    var imageObj = new Image()
    imageObj.onload = function () {
      var canvas, context
      var tileWidth = imageObj.height
      canvas = document.createElement('canvas')
      context = canvas.getContext('2d')
      canvas.height = tileWidth
      canvas.width = tileWidth
      context.drawImage(imageObj, 0, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth)
      Texture.image = canvas
      Texture.needsUpdate = true
    }
    imageObj.src = image
    return Texture
  }
}
export default Scene5



// WEBPACK FOOTER //
// ./src/js/views/Scene5.js